export default "__VITE_ASSET__DCiG8i5Z__"